/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/infra_open': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M9 7h8v6H9zM18 15h6l-4-3 4-3h-6zM9 14h1v10H9zM4.5 32H0v-4.5h1V31h3.5zM32 32h-4.5v-1H31v-3.5h1zM32 4.5h-1V1h-3.5V0H32zM1 4.5H0V0h4.5v1H1z"/>'
  }
})
